<template>
    <div class="table_head table_head_filter">
        <div class="flex flex_between">
            <div>
                <md-button class="md-blank margin_r" @click="showCsvReportModal(true)">
                    <i class="fa fa-cogs btn_icon" aria-hidden="true"></i>
                    {{ $t("investor.receivableHead.head.csv") }}
                </md-button>
                <md-button class="md-blank" @click="showDownloadDocumentsModal(true)">
                    <i class="fa fa-paperclip btn_icon" aria-hidden="true"></i>
                    {{$t("investor.receivableHead.head.download")}}
                </md-button>
            </div>
        </div>

        <AllInvestmentsReceivablesCsvReportModal
            v-if="csvReportModalShown"
            :account-id="accountId"
            @close="showCsvReportModal(false)"
        />

        <AllInvestmentsReceivablesDownloadAssignmentDocumentsModal
            v-if="downloadDocumentsModalShown"
            :account-id="accountId"
            @close="showDownloadDocumentsModal(false)"
        />
    </div>
</template>
<script>
import AllInvestmentsReceivablesCsvReportModal from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesCsvReportModal";
import AllInvestmentsReceivablesDownloadAssignmentDocumentsModal
    from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesDownloadAssignmentDocumentsModal";

export default {
    components: {
        AllInvestmentsReceivablesDownloadAssignmentDocumentsModal,
        AllInvestmentsReceivablesCsvReportModal
    },
    props: {
        accountId: Number,
    },
    data() {
        return {
            csvReportModalShown: false,
            downloadDocumentsModalShown: false,
            iconList: [
                { type: "del", iconName: "fa-trash", colorName: "secondary_color" },
                { type: "share", iconName: "fa-paper-plane", colorName: "accent_color" }
            ]
        };
    },
    methods: {
        showCsvReportModal(value) {
            this.csvReportModalShown = value;
        },
        showDownloadDocumentsModal(value) {
            this.downloadDocumentsModalShown = value;
        }
    }
};
</script>
